<template>
  <div class="container top-level-div">
    <div class="content-block">
      <div v-if="found">
        <div v-if="!editing">
          <h1>{{ content.title }}</h1>
          <hr>
          <!-- {{ content }} -->
          <pre class="" v-html="content.content"></pre>
          <hr>
          <button v-if="$store.getters.isAgent === 'true'" class="mylisting-button dark-button" @click="edit()">Edit</button>
        </div>

        <div v-if="editing">
          <input type="text" class="form-control" v-model="title">
          <div class="editor mt-4">
            <Modal ref="ytmodal" @onConfirm="addCommand" />
            <editor-menu-bar :editor="textEditor" v-slot="{ commands, isActive }" class="mb-1">
              <div class="menubar">
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                  <strong>B</strong>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                  <i>Italics</i>
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                  <u>U</u>
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                  Image
                </button> -->
                <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                  Image
                </button> -->
                <!-- https://github.com/scrumpy/tiptap/issues/89 -->
                <!-- https://codesandbox.io/s/j3p0z44155 -->
                <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                  Image
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                  H1
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                  H2
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                  H3
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                  List
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                  1. 2. 3...
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                  ""
                </button> -->
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                  ---
                </button>
                <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                  Undo
                </button>
                <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                  Redo
                </button> -->
              </div>
            </editor-menu-bar>

            <editor-menu-bubble class="menububble mb-1" :editor="textEditor" @hide="hideLinkMenu" v-slot="{ commands, isActive, getMarkAttrs, menu }">
              <div
                class="menububble"
                :class="{ 'is-active': menu.isActive }"
                :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
              >

                <!-- <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)"> -->
                <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.customlink, linkUrl)">
                  <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                  <!-- <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button"> -->
                  <!-- <button class="btn btn-grey btn-sm menubar__button" @click="setLinkUrl(commands.link, null)" type="button"> -->
                  <button class="btn btn-grey btn-sm menubar__button" @click="setLinkUrl(commands.customlink, null)" type="button">
                    <!-- <icon name="remove" /> -->
                    <p>remove</p>
                  </button>
                </form>

                <template v-else>
                  <!-- <button
                    class="menububble__button"
                    @click="showLinkMenu(getMarkAttrs('link'))"
                    :class="{ 'is-active': isActive.link() }"
                  > -->
                  <button
                    class="btn btn-grey btn-sm menubar__button"
                    @click="showLinkMenu(getMarkAttrs('link'))"
                    :class="{ 'is-active': isActive.link() }"
                  >
                    <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                    <!-- <icon name="link" /> -->
                  </button>
                </template>

              </div>
            </editor-menu-bubble>

            <editor-content class="editor__content" :editor="textEditor" />
          </div>
          <hr>
          <button v-if="$store.getters.isAgent" class="mylisting-button dark-button" @click="save()">Save</button>
        </div>
      </div>

      <div v-if="!found">
        <h1>Sorry! Not found.</h1>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

import CustomLink from '../global/CustomLink'

import Modal from "../employers/profile/Modal";

export default {
  data() {
    return {
      slug: null,
      found: true,
      editing: false,
      content: {},

      title: '',
      text: '',
      textEditor: null,

      linkUrl: null,
      linkMenuIsActive: false,
    }
  },
  components: {
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
    Modal,
  },
  created() {
    // Scroll the window up
    window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route

    this.slug = this.$route.params.slug
    this.getContent()
  },
  mounted() {
    this.textEditor = new Editor({
      // content: this.description,
      content: this.content.content,
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new CustomLink(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        this.text = getHTML()
      },
    })
  },
  beforeDestroy() {
    this.textEditor.destroy()
  },
  methods: {
    getContent() {
      axios.get('/api/contentpages/?agency='+this.$store.getters.agencyID.toString()+'&slug='+this.slug)
        .then(res => {
          console.log(res)
          this.content = res.data[0]
          document.title = res.data[0].title
          if (res.data.length == 0) {
            this.found = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    edit() {
      this.title = this.content.title
      this.textEditor.setContent(this.content.content)
      this.text = this.content.content
      this.editing = true

      // Scroll the window up
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    save() {
      axios.patch('/api/contentpages/'+this.content.id.toString()+'/', {
        title: this.title,
        content: this.text,
      })
        .then(res => {
          console.log(res)
          this.getContent()
          this.editing = false

          // Scroll the window up
          window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
        })
        .catch(error => {
          console.log(error)
        })
    },
    openModal(command) {
      this.$refs.ytmodal.showModal(command);
    },
    addCommand(data) {
      if (data.command !== null) {
        data.command(data.data);
      }
    },

    // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Links/index.vue
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu() {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl(command, url) {
      command({ href: url, target: '_blank' })
      this.hideLinkMenu()
    },
  },
}
</script>

<style>
  .ProseMirror {
    height: 4000px;
  }
</style>



// WEBPACK FOOTER //
// src/components/general/Content.vue